/**
 * GENERATED ADAPTATION by scripts/sync-home.sh — DO NOT EDIT.
 *
 * Minimal copy of the Console's MaximizeToggle (canonical:
 * tc-console/src/shell/MaximizeToggle.tsx), vendored standalone so the copied
 * HomeSurface's '../shell/MaximizeToggle' import resolves without pulling in
 * console shell code. In LV nothing passes onToggleMaximized to HomeSurface
 * (LvHomeSurface runs it bare), so this control never renders today — it
 * exists to keep the vendored renderer's import graph intact.
 */

import { IconButton, Tooltip } from '@mui/material'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'

export default function MaximizeToggle({
  maximized,
  onToggle,
}: {
  maximized: boolean
  onToggle: () => void
}) {
  return (
    <Tooltip title={maximized ? 'Exit full screen (Esc)' : 'Full screen'}>
      <IconButton
        size="small"
        onClick={onToggle}
        aria-label={maximized ? 'exit full screen' : 'full screen'}
        aria-pressed={maximized}
      >
        {maximized ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  )
}
